import { ISetWidthAction } from "../interfaces/utils.interface";

export function setDeviceWidth(width: number): ISetWidthAction {
  return {
    type: "SET_WIDTH",
    data: width,
  };
}
